var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('GmapMap',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":{ lat: +_vm.user.latitude, lng: +_vm.user.longitude },"zoom":12}},[_c('GmapMarker',{attrs:{"position":{ lat: +_vm.user.latitude, lng: +_vm.user.longitude },"clickable":true,"label":_vm.user.name,"draggable":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }